import { render, staticRenderFns } from "./ArticleDemandListItem.vue?vue&type=template&id=11ed55f9&scoped=true&"
import script from "./ArticleDemandListItem.vue?vue&type=script&lang=ts&"
export * from "./ArticleDemandListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ed55f9",
  null
  
)

export default component.exports